<div
    class="form-elements--wrapper"
    data-testid="t-deliveryterms-div-1752672977568-14"
>
    @if (showCustomerDiv()) {
        <form
            [formGroup]="deliverytermsForm"
            data-testid="t-deliveryterms-form-1752672977568-1"
        >
            <div
                class="row g-3"
                data-testid="t-deliveryterms-div-1752672977568-12"
            >
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-deliveryterms-div-1752672977568-4"
                >
                    <div
                        class="row g-1 align-items-end"
                        data-testid="t-deliveryterms-div-1752672977568-3"
                    >
                        @if (coreService.checkAbility('read', 'suppliercustomer.customernumber')) {
                            <div
                                class="col"
                                data-testid="t-deliveryterms-div-1752672977568-1"
                            >
                                <label
                                    for="customerNumber"
                                    class="form-label"
                                    data-testid="t-deliveryterms-label-1752672977568-1"
                                >
                                    {{ 'mws.customernumber' | i18n }}:
                                </label>
                                <input
                                    type="text"
                                    id="customerNumber"
                                    formControlName="customerNumber"
                                    class="form-control"
                                    [placeholder]="'mws.customernumber' | i18n"
                                    data-testid="t-deliveryterms-input-1752672977568-1"
                                />
                                <oc-validator-error
                                    [control]="basedataf.customerNumber"
                                    [propertyName]="'customerNumber'"
                                    [inputElementId]="'customerNumber'"
                                    data-testid="t-deliveryterms-oc-validator-error-1752672977568-1"
                                ></oc-validator-error>
                            </div>
                        }
                        @if (coreService.checkAbility('read', 'suppliercustomer.favorite')) {
                            <div
                                class="col-auto"
                                data-testid="t-deliveryterms-div-1752672977568-2"
                            >
                                @if (supplierContractCostcenterCustomer.isFavorite) {
                                    <span
                                        class="btn btn-primary action--btn"
                                        [attr.aria-label]="'mws.favorite' | i18n"
                                        style="cursor: not-allowed"
                                        data-testid="t-deliveryterms-span-1752672977568-1"
                                    >
                                        <i
                                            class="oc-heart-filled"
                                            data-testid="t-deliveryterms-i-1752672977568-1"
                                        ></i>
                                    </span>
                                }
                                @if (!supplierContractCostcenterCustomer.isFavorite) {
                                    <a
                                        class="btn btn-primary action--btn"
                                        ocPreventDoubleClick
                                        (throttledClick)="isFavorite()"
                                        [attr.aria-label]="'mws.favorite' | i18n"
                                        data-testid="t-deliveryterms-a-1752672977568-1"
                                    >
                                        <i
                                            [ngClass]="supplierContractCostcenterCustomer.isFavorite ? 'oc-heart-filled' : 'oc-heart-blank'"
                                            data-testid="t-deliveryterms-i-1752672977568-2"
                                        ></i>
                                    </a>
                                }
                            </div>
                        }
                    </div>
                </div>
                @if (coreService.checkAbility('read', 'suppliercustomer.customername')) {
                    <div
                        class="form-group col-md-6"
                        data-testid="t-deliveryterms-div-1752672977568-5"
                    >
                        <label
                            for="customerName"
                            class="form-label"
                            data-testid="t-deliveryterms-label-1752672977568-2"
                        >
                            {{ 'mws.customername' | i18n }}:
                        </label>
                        <input
                            type="text"
                            id="customerName"
                            formControlName="customerName"
                            class="form-control"
                            [placeholder]="'mws.customername' | i18n"
                            data-testid="t-deliveryterms-input-1752672977568-2"
                        />
                        <oc-validator-error
                            [control]="basedataf.customerName"
                            [propertyName]="'customerName'"
                            [inputElementId]="'customerName'"
                            data-testid="t-deliveryterms-oc-validator-error-1752672977568-2"
                        ></oc-validator-error>
                    </div>
                }
                @if (coreService.checkAbility('read', 'suppliercustomer.firstorderdate')) {
                    <div
                        class="form-group col-12"
                        data-testid="t-deliveryterms-div-1752672977568-6"
                    >
                        <label
                            for="firstorderdate"
                            class="form-label"
                            data-testid="t-deliveryterms-label-1752672977568-3"
                        >
                            {{ 'mws.firstorderdate' | i18n }} :
                        </label>
                        <input
                            type="text"
                            id="firstorderdate"
                            formControlName="firstorderdate"
                            class="form-control"
                            [placeholder]="'mws.firstorderdate' | i18n"
                            data-testid="t-deliveryterms-input-1752672977568-3"
                        />
                    </div>
                }
                @if (coreService.checkAbility('read', 'suppliercontractcostcentercustomer.minimusordervalue')) {
                    <div
                        class="form-group col-12 col-md-6"
                        data-testid="t-deliveryterms-div-1752672977568-10"
                    >
                        <label
                            for="minimumOrderValue"
                            class="form-label"
                            data-testid="t-deliveryterms-label-1752672977568-4"
                        >
                            {{ 'mws.minimumordervalue' | i18n }} :
                        </label>
                        <div
                            class="input-group"
                            data-testid="t-deliveryterms-div-1752672977568-9"
                        >
                            <input
                                type="text"
                                id="minimumOrderValue"
                                formControlName="minimumOrderValue"
                                integerValue
                                ocPreventDoubleClick
                                (throttledClick)="$any($event.target).select()"
                                class="form-control"
                                placeholder=""
                                data-testid="t-deliveryterms-input-1752672977568-4"
                            />
                            <div
                                class="input-group-append"
                                data-testid="t-deliveryterms-div-1752672977568-8"
                            >
                                <div
                                    class="input-group-text"
                                    data-testid="t-deliveryterms-div-1752672977568-7"
                                >
                                    @if (supplierService.supplierBasedata.currencyId) {
                                        <span data-testid="t-deliveryterms-span-1752672977568-2">{{
                                            environmentService.currencyHash.get(supplierService.supplierBasedata.currencyId).iso4217Code
                                        }}</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (coreService.checkAbility('read', 'suppliercustomer.currency')) {
                    <div
                        class="form-group col-md-6"
                        data-testid="t-deliveryterms-div-1752672977568-11"
                    >
                        <label
                            class="form-label"
                            data-testid="t-deliveryterms-label-1752672977568-5"
                            >{{ 'mws.currencyoninvoice' | i18n }}:</label
                        >
                        <select
                            class="form-select"
                            formControlName="currencyId"
                            data-testid="t-deliveryterms-select-1752672977568-1"
                        >
                            @for (cur of environmentService.currencyList; track cur) {
                                <option
                                    [ngValue]="cur.id"
                                    data-testid="t-deliveryterms-option-1752672977568-1"
                                >
                                    {{ cur.descr }}
                                </option>
                            }
                        </select>
                    </div>
                }
            </div>
            @if (showButtons()) {
                <div
                    class="button-wrapper"
                    data-testid="t-deliveryterms-div-1752672977568-13"
                >
                    @if (coreService.checkAbility('execute', 'suppliercustomer.delete')) {
                        <button
                            type="button"
                            id="contractCostcenterCustomer-delete"
                            [attr.aria-label]="'button.delete' | i18n"
                            class="btn btn-danger me-auto action--btn"
                            ocPreventDoubleClick
                            (throttledClick)="checkArchiveCustomer(supplierContractCostcenterCustomer.id)"
                            data-testid="t-deliveryterms-button-1752672977568-1"
                        >
                            <i
                                class="oc-trash-can"
                                data-testid="t-deliveryterms-i-1752672977568-3"
                            ></i>
                        </button>
                    }
                    @if (coreService.checkAbility('execute', 'suppliercustomer.edit')) {
                        <button
                            type="button"
                            id="contractCostcenterCustomer-cancel"
                            [attr.aria-label]="'button.discard' | i18n"
                            class="btn btn-danger"
                            ocPreventDoubleClick
                            (throttledClick)="cancelCustomer()"
                            [disabled]="!deliverytermsForm.get('changed').touched"
                            data-testid="t-deliveryterms-button-1752672977568-2"
                        >
                            <i
                                class="oc-general-cancel"
                                data-testid="t-deliveryterms-i-1752672977568-4"
                            ></i>
                        </button>
                    }
                    @if (coreService.checkAbility('execute', 'suppliercustomer.edit')) {
                        <button
                            type="button"
                            id="contractCostcenterCustomer-success"
                            [attr.aria-label]="'button.check' | i18n"
                            class="btn btn-success"
                            ocPreventDoubleClick
                            (throttledClick)="onSaveCustomer()"
                            [disabled]="!deliverytermsForm.get('changed').touched"
                            data-testid="t-deliveryterms-button-1752672977568-3"
                        >
                            <i
                                class="oc-general-check"
                                data-testid="t-deliveryterms-i-1752672977568-5"
                            ></i>
                        </button>
                    }
                </div>
            }
        </form>
    }
</div>
<!-- BESTELLTAGE -->
<!-- BESTELLTAGE -->
<!-- BESTELLTAGE -->

<div
    class="form-elements--wrapper"
    data-testid="t-deliveryterms-div-1752672977568-29"
>
    <div
        class="add--header"
        data-testid="t-deliveryterms-div-1752672977568-17"
    >
        <div
            class="col"
            data-testid="t-deliveryterms-div-1752672977568-15"
        >
            <span
                class="h5"
                data-testid="t-deliveryterms-span-1752672977568-3"
                >{{ 'mws.orderdays' | i18n }}:</span
            >
        </div>
        @if (showButtons()) {
            <div
                class="col-auto text-end"
                data-testid="t-deliveryterms-div-1752672977568-16"
            >
                <a
                    class="btn btn-sm btn-primary action--btn"
                    [attr.aria-label]="'mws.add' | i18n"
                    ocPreventDoubleClick
                    (throttledClick)="openOrderdaysModal()"
                    data-testid="t-deliveryterms-a-1752672977568-2"
                    ><i
                        class="oc-plus"
                        data-testid="t-deliveryterms-i-1752672977568-6"
                    ></i></a
                >&nbsp;
            </div>
        }
    </div>
    <!--
    nächste Bestellung am: xx.xx.xxxx
    ACHTUNG: Soll lt. RA 2020-06-17 momentan nicht angezeigt werden !!!
    -->
    <!--<div class="col-12">-->
    <!--    <div>-->
    <!--        {{'mws.nextorderday' | i18n}}: xx.xx.xxxx-->
    <!--    </div>-->
    <!--</div>-->
    <div
        class="table-oc-responsive table-datetime table-responsive table-scrollable"
        data-testid="t-deliveryterms-div-1752672977568-28"
    >
        <table
            [dataSource]="orderdaysTableModel"
            cdk-table
            class="table"
            data-testid="t-deliveryterms-table-1752672977568-1"
        >
            <ng-container cdkColumnDef="datefrom">
                <th
                    style="width: 1%"
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-1"
                >
                    {{ 'mws.datefrom' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-1"
                >
                    {{ element.datefromDSP }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="datetill">
                <th
                    style="width: 1%"
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-2"
                >
                    {{ 'mws.datetill' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-2"
                >
                    {{ element.datetillDSP }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_0">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-3"
                >
                    {{ supplierService.day_0_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-3"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-19"
                    >
                        <input
                            class="form-check-input"
                            disabled
                            type="checkbox"
                            [(ngModel)]="element.day_0"
                            data-testid="t-deliveryterms-input-1752672977568-5"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-6"
                            >{{ element.day_0_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_1">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-4"
                >
                    {{ supplierService.day_1_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-4"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-20"
                    >
                        <input
                            class="form-check-input"
                            disabled
                            type="checkbox"
                            [(ngModel)]="element.day_1"
                            data-testid="t-deliveryterms-input-1752672977568-6"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-7"
                            >{{ element.day_1_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_2">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-5"
                >
                    {{ supplierService.day_2_title }}
                </th>
                <td
                    class="td-checkbox"
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-5"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-21"
                    >
                        <input
                            class="form-check-input"
                            disabled
                            type="checkbox"
                            [(ngModel)]="element.day_2"
                            data-testid="t-deliveryterms-input-1752672977568-7"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-8"
                        >
                            {{ element.day_2_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_3">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-6"
                >
                    {{ supplierService.day_3_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-6"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-22"
                    >
                        <input
                            class="form-check-input"
                            disabled
                            type="checkbox"
                            [(ngModel)]="element.day_3"
                            data-testid="t-deliveryterms-input-1752672977568-8"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-9"
                            >{{ element.day_3_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_4">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-7"
                >
                    {{ supplierService.day_4_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-7"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-23"
                    >
                        <input
                            class="form-check-input"
                            disabled
                            type="checkbox"
                            [(ngModel)]="element.day_4"
                            data-testid="t-deliveryterms-input-1752672977568-9"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-10"
                            >{{ element.day_4_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_5">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-8"
                >
                    {{ supplierService.day_5_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-8"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-24"
                    >
                        <input
                            class="form-check-input"
                            disabled
                            type="checkbox"
                            [(ngModel)]="element.day_5"
                            data-testid="t-deliveryterms-input-1752672977568-10"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-11"
                            >{{ element.day_5_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_6">
                <div
                    class=""
                    data-testid="t-deliveryterms-div-1752672977568-18"
                >
                    <th
                        cdk-header-cell
                        *cdkHeaderCellDef
                        data-testid="t-deliveryterms-th-1752672977568-9"
                    >
                        {{ supplierService.day_6_title }}
                    </th>
                    <td
                        cdk-cell
                        *cdkCellDef="let element"
                        data-testid="t-deliveryterms-td-1752672977568-9"
                    >
                        <div
                            class="form-check"
                            data-testid="t-deliveryterms-div-1752672977568-25"
                        >
                            <input
                                class="form-check-input"
                                disabled
                                type="checkbox"
                                [(ngModel)]="element.day_6"
                                data-testid="t-deliveryterms-input-1752672977568-11"
                            />
                            <label
                                class="form-check-label"
                                data-testid="t-deliveryterms-label-1752672977568-12"
                                >{{ element.day_6_time }}</label
                            >
                        </div>
                    </td>
                </div>
            </ng-container>
            <ng-container cdkColumnDef="orderDetail">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-10"
                >
                    {{ 'mws.orderfrequency' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-10"
                >
                    @if (+element.orderRhythm === 1) {
                        <div data-testid="t-deliveryterms-div-1752672977568-26">
                            @if (element.isOrderRhythmWeekly) {
                                <span data-testid="t-deliveryterms-span-1752672977568-4"> {{ 'mws.weekly' | i18n }}</span>
                            }
                            @if (element.isOrderRhythmMonthly) {
                                <span data-testid="t-deliveryterms-span-1752672977568-5"> {{ 'mws.monthly' | i18n }}</span>
                            }
                        </div>
                    }
                    @if (+element.orderRhythm > 1) {
                        <div data-testid="t-deliveryterms-div-1752672977568-27">
                            @if (element.isOrderRhythmWeekly) {
                                <span data-testid="t-deliveryterms-span-1752672977568-6">
                                    {{ 'mws.supplierorderdayweekly' | i18n: 'notr:' + [element.orderRhythm] }}</span
                                >
                            }
                            @if (element.isOrderRhythmMonthly) {
                                <span data-testid="t-deliveryterms-span-1752672977568-7">
                                    {{ 'mws.supplierorderdaymonthly' | i18n: 'notr:' + [element.orderRhythm] }}</span
                                >
                            }
                        </div>
                    }
                </td>
            </ng-container>
            <ng-container cdkColumnDef="orderLeadTimeDays">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-11"
                >
                    {{ 'mws.orderleadindays' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-11"
                >
                    <span data-testid="t-deliveryterms-span-1752672977568-8">{{ element.orderLeadTimeDays }}</span>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="buttons">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-12"
                ></th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    class="align-right"
                    align="right"
                    data-testid="t-deliveryterms-td-1752672977568-12"
                >
                    @if (showButtons()) {
                        <a
                            ocPreventDoubleClick
                            (throttledClick)="openOrderdaysModal(element)"
                            class="btn btn-sm action--btn btn-primary"
                            [attr.aria-label]="'mws.edit' | i18n"
                            data-testid="t-deliveryterms-a-1752672977568-3"
                        >
                            <i
                                class="oc-general-edit"
                                data-testid="t-deliveryterms-i-1752672977568-7"
                            ></i
                        ></a>
                    }
                    <!--                <a (click)="archiveOrderdaysOpenModal(elementRef.id)" class="btn btn-sm action&#45;&#45;btn" [attr.aria-label]="'mws.archive' | i18n"-->
                    <!--                  ><i-->
                    <!--                    class="oc-archive"></i></a>-->
                </td>
            </ng-container>
            <tr
                cdk-header-row
                *cdkHeaderRowDef="displayedColumnsOrderdays"
                data-testid="t-deliveryterms-tr-1752672977568-1"
            ></tr>
            <tr
                cdk-row
                *cdkRowDef="let row; columns: displayedColumnsOrderdays"
                data-testid="t-deliveryterms-tr-1752672977568-2"
            ></tr>
        </table>
    </div>
</div>
<div
    class="form-elements--wrapper"
    data-testid="t-deliveryterms-div-1752672977568-41"
>
    <!-- LIEFERTAGE -->

    <div
        class="add--header"
        data-testid="t-deliveryterms-div-1752672977568-32"
    >
        <div
            class="col"
            data-testid="t-deliveryterms-div-1752672977568-30"
        >
            <span
                class="h5"
                data-testid="t-deliveryterms-span-1752672977568-9"
                >{{ 'mws.deliverydays' | i18n }}:</span
            >
        </div>
        @if (showButtons()) {
            <div
                class="col-auto text-end"
                data-testid="t-deliveryterms-div-1752672977568-31"
            >
                <a
                    class="btn btn-sm btn-primary action--btn"
                    [attr.aria-label]="'mws.add' | i18n"
                    ocPreventDoubleClick
                    (throttledClick)="openDeliverydaysCustomerModal()"
                    data-testid="t-deliveryterms-a-1752672977568-4"
                    ><i
                        class="oc-plus"
                        data-testid="t-deliveryterms-i-1752672977568-8"
                    ></i
                ></a>
            </div>
        }
    </div>

    <div
        class="table-oc-responsive table-datetime table-responsive table-scrollable"
        data-testid="t-deliveryterms-div-1752672977568-40"
    >
        <table
            cdk-table
            [dataSource]="deliverdaysTableModel"
            class="table"
            data-testid="t-deliveryterms-table-1752672977568-2"
        >
            <ng-container cdkColumnDef="datefrom">
                <th
                    style="width: 1%"
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-13"
                >
                    {{ 'mws.datefrom' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-13"
                >
                    <span data-testid="t-deliveryterms-span-1752672977568-10">{{ element.datefromDSP }}</span>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="datetill">
                <th
                    style="width: 1%"
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-14"
                >
                    {{ 'mws.datetill' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-14"
                >
                    <span data-testid="t-deliveryterms-span-1752672977568-11">{{ element.datetillDSP }}</span>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_0">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-15"
                >
                    {{ supplierService.day_0_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-15"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-33"
                    >
                        <input
                            class="form-check-input"
                            type="checkbox"
                            disabled
                            [(ngModel)]="element.day_0"
                            data-testid="t-deliveryterms-input-1752672977568-12"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-13"
                            >{{ element.day_0_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_1">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-16"
                >
                    {{ supplierService.day_1_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-16"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-34"
                    >
                        <input
                            class="form-check-input"
                            type="checkbox"
                            disabled
                            [(ngModel)]="element.day_1"
                            data-testid="t-deliveryterms-input-1752672977568-13"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-14"
                            >{{ element.day_1_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_2">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-17"
                >
                    {{ supplierService.day_2_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-17"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-35"
                    >
                        <input
                            class="form-check-input"
                            type="checkbox"
                            disabled
                            [(ngModel)]="element.day_2"
                            data-testid="t-deliveryterms-input-1752672977568-14"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-15"
                            >{{ element.day_2_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_3">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-18"
                >
                    {{ supplierService.day_3_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-18"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-36"
                    >
                        <input
                            class="form-check-input"
                            type="checkbox"
                            disabled
                            [(ngModel)]="element.day_3"
                            data-testid="t-deliveryterms-input-1752672977568-15"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-16"
                            >{{ element.day_3_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_4">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-19"
                >
                    {{ supplierService.day_4_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-19"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-37"
                    >
                        <input
                            class="form-check-input"
                            type="checkbox"
                            disabled
                            [(ngModel)]="element.day_4"
                            data-testid="t-deliveryterms-input-1752672977568-16"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-17"
                            >{{ element.day_4_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_5">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-20"
                >
                    {{ supplierService.day_5_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-20"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-38"
                    >
                        <input
                            class="form-check-input"
                            type="checkbox"
                            disabled
                            [(ngModel)]="element.day_5"
                            data-testid="t-deliveryterms-input-1752672977568-17"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-18"
                            >{{ element.day_5_time }}</label
                        >
                    </div>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="day_6">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-21"
                >
                    {{ supplierService.day_6_title }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-21"
                >
                    <div
                        class="form-check"
                        data-testid="t-deliveryterms-div-1752672977568-39"
                    >
                        <input
                            class="form-check-input"
                            type="checkbox"
                            disabled
                            [(ngModel)]="element.day_6"
                            data-testid="t-deliveryterms-input-1752672977568-18"
                        />
                        <label
                            class="form-check-label"
                            data-testid="t-deliveryterms-label-1752672977568-19"
                            >{{ element.day_6_time }}</label
                        >
                    </div>
                </td>
            </ng-container>

            <ng-container cdkColumnDef="buttons">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-22"
                ></th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    class="align-right"
                    align="right"
                    data-testid="t-deliveryterms-td-1752672977568-22"
                >
                    @if (showButtons()) {
                        <a
                            ocPreventDoubleClick
                            (throttledClick)="openDeliverydaysCustomerModal(element)"
                            class="btn btn-sm action--btn btn-primary"
                            [attr.aria-label]="'mws.edit' | i18n"
                            data-testid="t-deliveryterms-a-1752672977568-5"
                        >
                            <i
                                class="oc-general-edit"
                                data-testid="t-deliveryterms-i-1752672977568-9"
                            ></i
                        ></a>
                    }
                    <!--                <a (click)="archiveDeliverydaysOpenModal(elementRef.id)" class="btn btn-sm action&#45;&#45;btn" [attr.aria-label]="'mws.archive' | i18n"-->
                    <!--                  ><i-->
                    <!--                    class="oc-archive"></i></a>-->
                </td>
            </ng-container>

            <tr
                cdk-header-row
                *cdkHeaderRowDef="displayedColumnsDeliverydays"
                data-testid="t-deliveryterms-tr-1752672977568-3"
            ></tr>
            <tr
                cdk-row
                *cdkRowDef="let row; columns: displayedColumnsDeliverydays"
                data-testid="t-deliveryterms-tr-1752672977568-4"
            ></tr>
        </table>
    </div>
</div>
<div
    class="form-elements--wrapper"
    data-testid="t-deliveryterms-div-1752672977568-46"
>
    <!-- FEIERTAGSLIEFERUNGEN -->
    <div
        class="add--header"
        data-testid="t-deliveryterms-div-1752672977568-44"
    >
        <div
            class="col"
            data-testid="t-deliveryterms-div-1752672977568-42"
        >
            <span
                class="h5"
                data-testid="t-deliveryterms-span-1752672977568-12"
                >{{ 'mws.holidaydeliveries' | i18n }}:</span
            >
        </div>
        @if (showButtons()) {
            <div
                class="col-auto text-end"
                data-testid="t-deliveryterms-div-1752672977568-43"
            >
                <a
                    class="btn btn-sm btn-primary action--btn"
                    [attr.aria-label]="'mws.add' | i18n"
                    ocPreventDoubleClick
                    (throttledClick)="openDeliveryTermHolidaysModal()"
                    data-testid="t-deliveryterms-a-1752672977568-6"
                    ><i
                        class="oc-plus"
                        data-testid="t-deliveryterms-i-1752672977568-10"
                    ></i
                ></a>
            </div>
        }
    </div>

    <div
        class="table-oc-responsive table-datetime table-responsive table-scrollable"
        data-testid="t-deliveryterms-div-1752672977568-45"
    >
        <table
            cdk-table
            [dataSource]="supplierService.supplierCustomerDetails?.supplierDeliveryTermHolidays"
            class="table"
            data-testid="t-deliveryterms-table-1752672977568-3"
        >
            <ng-container cdkColumnDef="date">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-23"
                >
                    {{ 'mws.date' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-23"
                >
                    {{ element._holidayDateDSP }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="time">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-24"
                >
                    {{ 'mws.deliverytime' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-24"
                >
                    {{ element.timeHoliday }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="desc">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-25"
                >
                    {{ 'mws.descr' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-deliveryterms-td-1752672977568-25"
                >
                    {{ element.holiday['descr'] }}
                </td>
            </ng-container>

            <ng-container cdkColumnDef="buttons">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-deliveryterms-th-1752672977568-26"
                ></th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    align="right"
                    data-testid="t-deliveryterms-td-1752672977568-26"
                >
                    @if (showButtons()) {
                        <a
                            ocPreventDoubleClick
                            (throttledClick)="openDeliveryTermHolidaysModal(element)"
                            class="btn btn-sm action--btn btn-primary"
                            [attr.aria-label]="'mws.edit' | i18n"
                            data-testid="t-deliveryterms-a-1752672977568-7"
                            ><i
                                class="oc-general-edit"
                                data-testid="t-deliveryterms-i-1752672977568-11"
                            ></i
                        ></a>
                    }
                    @if (showButtons()) {
                        <a
                            ocPreventDoubleClick
                            (throttledClick)="archiveHolidaysOpenModal(element.id)"
                            class="btn btn-danger btn-sm action--btn"
                            [attr.aria-label]="'mws.archive' | i18n"
                            data-testid="t-deliveryterms-a-1752672977568-8"
                            ><i
                                class="oc-trash-can"
                                data-testid="t-deliveryterms-i-1752672977568-12"
                            ></i
                        ></a>
                    }
                </td>
            </ng-container>

            <tr
                cdk-header-row
                *cdkHeaderRowDef="displayedColumnsHolidays"
                data-testid="t-deliveryterms-tr-1752672977568-5"
            ></tr>
            <tr
                cdk-row
                *cdkRowDef="let row; columns: displayedColumnsHolidays"
                data-testid="t-deliveryterms-tr-1752672977568-6"
            ></tr>
        </table>
    </div>
</div>

<!-- ADDRESSES -->
<!-- ADDRESSES -->
<!-- ADDRESSES -->
<!--[addresses]="supplierService.supplierContractCostcenterCustomerDetails?.supplierCustomerAddresses"-->
@if (showAddresses()) {
    <div
        class="form-elements--wrapper"
        data-testid="t-deliveryterms-div-1752672977568-47"
    >
        <app-addresses
            [privilegeContext]="'supplier.contract.costcenter.customer'"
            [addresses]="addresses"
            [title]="deliverytermsAddressTitle"
            [isModal]="false"
            [showAddressType]="false"
            [addressesForPrefill]="costcenterAddresses()"
            [addressesPrefillButtonText]="'mws.shippingaddresscostcenter.takeover' | i18n"
            [allowRemoveFavorite]="false"
            (onSubmit)="onSubmitAddress($event)"
            (onDelete)="onDeleteAddress($event)"
            data-testid="t-deliveryterms-app-addresses-1752672977568-1"
        ></app-addresses>
    </div>
}

<ng-template
    #orderdaysModal
    let-c="close"
    let-d="dismiss"
>
    <!--    (ngSubmit)="submit(supplierContactForm)"-->
    <form
        [formGroup]="orderdaysModalForm"
        data-testid="t-deliveryterms-form-1752672977568-2"
    >
        <div
            class="modal-header"
            data-testid="t-deliveryterms-div-1752672977568-48"
        >
            <button
                type="button"
                id="orderdays-cancel"
                [attr.aria-label]="'button.discard' | i18n"
                class="btn btn-close"
                ocPreventDoubleClick
                (throttledClick)="d('Close click')"
                data-testid="t-deliveryterms-button-1752672977568-4"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-deliveryterms-i-1752672977568-13"
                ></i>
            </button>
            <span
                class="h5 modal-title"
                data-testid="t-deliveryterms-span-1752672977568-13"
                >{{ 'mws.supplierconditionadd' | i18n }}</span
            >
        </div>

        <div
            class="modal-body"
            data-testid="t-deliveryterms-div-1752672977568-73"
        >
            <div
                class="add--header"
                data-testid="t-deliveryterms-div-1752672977568-49"
            >
                <span
                    class="h5"
                    data-testid="t-deliveryterms-span-1752672977568-14"
                >
                    {{ 'mws.validweekdays' | i18n }}
                </span>
            </div>

            <div
                class="form-elements--wrapper"
                data-testid="t-deliveryterms-div-1752672977568-58"
            >
                <div
                    class="row g-3"
                    data-testid="t-deliveryterms-div-1752672977568-57"
                >
                    @for (control of orderdaysDayforms.controls; track control) {
                        <div
                            class="form-group col-md-6 col-lg-4"
                            [formGroup]="control | ocCast"
                            data-testid="t-deliveryterms-div-1752672977568-56"
                        >
                            <div
                                class="datetime--picker"
                                data-testid="t-deliveryterms-div-1752672977568-55"
                            >
                                <div data-testid="t-deliveryterms-div-1752672977568-50">
                                    <strong data-testid="t-deliveryterms-strong-1752672977568-1">{{ 'mws.calendar' + control.get('day').value | i18n }}</strong>
                                </div>
                                <div
                                    class="row g-3 align-items-center"
                                    data-testid="t-deliveryterms-div-1752672977568-54"
                                >
                                    <div
                                        class="col-auto"
                                        data-testid="t-deliveryterms-div-1752672977568-52"
                                    >
                                        <div
                                            class="form-check checkbox-big"
                                            data-testid="t-deliveryterms-div-1752672977568-51"
                                        >
                                            <input
                                                type="checkbox"
                                                [id]="'isWeekday' + control.get('day').value"
                                                id="isWeekday"
                                                formControlName="isWeekday"
                                                class="form-check-input mb-0"
                                                data-testid="t-deliveryterms-input-1752672977568-19"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="col"
                                        data-testid="t-deliveryterms-div-1752672977568-53"
                                    >
                                        <ngb-timepicker
                                            formControlName="time"
                                            [readonlyInputs]="!control.get('isWeekday').value"
                                            [hourStep]="!control.get('isWeekday').value ? 0 : 1"
                                            [minuteStep]="!control.get('isWeekday').value ? 0 : 1"
                                            data-testid="t-deliveryterms-ngb-timepicker-1752672977568-1"
                                        ></ngb-timepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <div
                class="form-elements--wrapper"
                data-testid="t-deliveryterms-div-1752672977568-67"
            >
                <div
                    class="add--header"
                    data-testid="t-deliveryterms-div-1752672977568-59"
                >
                    <span
                        class="h5"
                        data-testid="t-deliveryterms-span-1752672977568-15"
                    >
                        {{ 'mws.orderrhythm' | i18n }} / {{ 'mws.orderforerun' | i18n }}
                    </span>
                </div>
                <div
                    class=""
                    data-testid="t-deliveryterms-div-1752672977568-66"
                >
                    <div
                        class="row g-3 align-items-end"
                        data-testid="t-deliveryterms-div-1752672977568-65"
                    >
                        <div
                            class="col-2 form-group"
                            data-testid="t-deliveryterms-div-1752672977568-60"
                        >
                            <oc-label
                                [forElement]="'orderRhythm'"
                                [schema]="'supplierDeliveryTermDay'"
                                [propertyName]="'orderRhythm'"
                                [value]="'mws.all' | i18n"
                                [classes]="'form-label'"
                                data-testid="t-deliveryterms-oc-label-1752672977568-1"
                            ></oc-label>

                            <input
                                ocAutoselect
                                type="text"
                                class="form-control"
                                id="orderRhythm"
                                formControlName="orderRhythm"
                                value="1"
                                data-testid="t-deliveryterms-input-1752672977568-20"
                            />
                            @if (orderdaysModalForm.get('orderRhythm').errors?.['pattern']) {
                                <div
                                    class="alert alert-danger"
                                    data-testid="t-deliveryterms-div-1778158590764-1"
                                >
                                    {{ 'mws.error.onlynumbericvalues' | i18n }}
                                </div>
                            }
                        </div>

                        <div
                            class="col-auto form-group"
                            data-testid="t-deliveryterms-div-1752672977568-62"
                        >
                            <!--<div class="btn-group">
              <input type="button" class="btn btn-sm btn-secondary" formControlName="isWeekly"
                />
              <input type="button" class="btn btn-sm btn-secondary" formControlName="isMonthly"
                [innerText]="'mws.supplierOrderDayMonthly' | i18n"/>
            </div>-->
                            <div
                                class="select-wrapper"
                                data-testid="t-deliveryterms-div-1752672977568-61"
                            >
                                <select
                                    class="form-select"
                                    id="orderRhytm"
                                    formControlName="rhythm"
                                    data-testid="t-deliveryterms-select-1752672977568-2"
                                >
                                    <option
                                        value="weekly"
                                        [value]="1"
                                        data-testid="t-deliveryterms-option-1752672977568-2"
                                    >
                                        {{ 'mws.weeks' | i18n }}
                                    </option>
                                    <option
                                        value="monthly"
                                        [value]="2"
                                        data-testid="t-deliveryterms-option-1752672977568-3"
                                    >
                                        {{ 'mws.months' | i18n }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div
                            class="col-auto"
                            data-testid="t-deliveryterms-div-1752672977568-64"
                        >
                            <div
                                class="form-group"
                                data-testid="t-deliveryterms-div-1752672977568-63"
                            >
                                <oc-label
                                    [forElement]="'orderLeadTimeDays'"
                                    [schema]="'supplierDeliveryTermDay'"
                                    [propertyName]="'orderLeadTimeDays'"
                                    [value]="'mws.orderleadindays' | i18n"
                                    [classes]="'form-label'"
                                    data-testid="t-deliveryterms-oc-label-1752672977568-2"
                                ></oc-label>
                                <input
                                    ocAutoselect
                                    type="text"
                                    class="form-control"
                                    id="orderLeadTimeDays"
                                    formControlName="orderLeadTimeDays"
                                    maxlength="2"
                                    required
                                    placeholder="{{ 'mws.orderleadindays' | i18n }}"
                                    data-testid="t-deliveryterms-input-1752672977568-21"
                                />
                                @if (orderdaysModalForm.get('orderLeadTimeDays').errors?.['pattern']) {
                                    <div
                                        class="alert alert-danger"
                                        data-testid="t-deliveryterms-div-1778158590764-2"
                                    >
                                        {{ 'mws.error.onlynumbericvalues' | i18n }}
                                    </div>
                                }
                                @if (orderdaysModalForm.get('orderLeadTimeDays').errors?.max) {
                                    <div
                                        class="alert alert-danger"
                                        data-testid="t-deliveryterms-div-1778158590764-3"
                                    >
                                        {{ 'mws.maximumpossiblevalue' | i18n }} 15
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="form-elements--wrapper"
                data-testid="t-deliveryterms-div-1752672977568-72"
            >
                <div
                    class="add--header"
                    data-testid="t-deliveryterms-div-1752672977568-68"
                >
                    <span
                        class="h5"
                        data-testid="t-deliveryterms-span-1752672977568-16"
                    >
                        {{ 'mws.validityperiod' | i18n }}
                    </span>
                </div>
                <div
                    class="row g-3"
                    data-testid="t-deliveryterms-div-1752672977568-71"
                >
                    <div
                        class="form-group col-6"
                        data-testid="t-deliveryterms-div-1752672977568-69"
                    >
                        <app-oc-datepicker
                            [title]="'mws.datefrom' | i18n"
                            [schema]="'supplierDeliveryTermDay'"
                            [propertyName]="'validFrom'"
                            [locale]="environmentService.appSettings.locale.split('_')[0]"
                            [form]="dateFromFormOrderdaysModalForm"
                            [disabled]="systemMethod === systemMethodEnum.EDIT && !!orderdaysModalForm.get('dateFromForm').get('date').value.singleDate"
                            (dateChange)="onDateFromChanged($event, orderdaysModalForm, orderFormType)"
                            data-testid="t-deliveryterms-app-oc-datepicker-1752672977568-1"
                        ></app-oc-datepicker>
                    </div>

                    <div
                        class="col-6"
                        data-testid="t-deliveryterms-div-1752672977568-70"
                    >
                        <app-oc-datepicker
                            [title]="'mws.datetill' | i18n"
                            [locale]="environmentService.appSettings.locale.split('_')[0]"
                            [form]="dateTillFormOrderdaysModalForm"
                            [disabled]="!orderdaysModalForm.get('dateFromForm').get('date').value.singleDate"
                            [showClearDate]="orderdaysModalForm.get('isLast').value"
                            data-testid="t-deliveryterms-app-oc-datepicker-1752672977568-2"
                        ></app-oc-datepicker>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal-footer"
            data-testid="t-deliveryterms-div-1752672977568-75"
        >
            <div
                class="button-wrapper"
                data-testid="t-deliveryterms-div-1752672977568-74"
            >
                <button
                    type="button"
                    id="orderdays-success"
                    [attr.aria-label]="'button.check' | i18n"
                    class="btn btn-success"
                    ocPreventDoubleClick
                    (throttledClick)="checkSaveOrderDay()"
                    [disabled]="!orderdaysModalForm.get('changed').touched"
                    data-testid="t-deliveryterms-button-1752672977568-5"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-deliveryterms-i-1752672977568-14"
                    ></i>
                </button>
            </div>
        </div>
    </form>
</ng-template>

<ng-template
    #deliverydaysCustomerModal
    let-c="close"
    let-d="dismiss"
>
    <!--    (ngSubmit)="submit(supplierContactForm)"-->
    <form
        [formGroup]="deliverydaysCustomerModalForm"
        novalidate
        data-testid="t-deliveryterms-form-1752672977568-3"
    >
        <div
            class="modal-header"
            data-testid="t-deliveryterms-div-1752672977568-76"
        >
            <button
                type="button"
                id="deliverydays-cancel"
                [attr.aria-label]="'button.discard' | i18n"
                class="btn btn-close"
                ocPreventDoubleClick
                (throttledClick)="d('Close click')"
                data-testid="t-deliveryterms-button-1752672977568-6"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-deliveryterms-i-1752672977568-15"
                ></i>
            </button>
            <h5
                class="modal-title"
                data-testid="t-deliveryterms-span-1752672977568-17"
            >
                {{ 'mws.supplierdeliverydayadd' | i18n }}
            </h5>
        </div>

        <div
            class="modal-body"
            data-testid="t-deliveryterms-div-1752672977568-92"
        >
            <div
                class="add--header"
                data-testid="t-deliveryterms-div-1752672977568-77"
            >
                <span
                    class="h5"
                    data-testid="t-deliveryterms-span-1752672977568-18"
                >
                    {{ 'mws.validweekdays' | i18n }}
                </span>
            </div>

            <div
                class="form-elements--wrapper"
                data-testid="t-deliveryterms-div-1752672977568-86"
            >
                <div
                    class="row g-3"
                    data-testid="t-deliveryterms-div-1752672977568-85"
                >
                    @for (control of deliverydaysDayforms.controls; track control) {
                        <div
                            class="form-group col-md-6 col-lg-4"
                            [formGroup]="control | ocCast"
                            data-testid="t-deliveryterms-div-1752672977568-84"
                        >
                            <div
                                class="datetime--picker"
                                data-testid="t-deliveryterms-div-1752672977568-83"
                            >
                                <div data-testid="t-deliveryterms-div-1752672977568-78">
                                    <strong data-testid="t-deliveryterms-strong-1752672977568-2">{{ 'mws.calendar' + control.get('day').value | i18n }}</strong>
                                </div>
                                <div
                                    class="row g-3 align-items-center"
                                    data-testid="t-deliveryterms-div-1752672977568-82"
                                >
                                    <div
                                        class="col-auto"
                                        data-testid="t-deliveryterms-div-1752672977568-80"
                                    >
                                        <div
                                            class="form-check checkbox-big"
                                            data-testid="t-deliveryterms-div-1752672977568-79"
                                        >
                                            <input
                                                type="checkbox"
                                                [id]="'isWeekday' + control.get('day').value"
                                                formControlName="isWeekday"
                                                class="form-check-input mb-0"
                                                data-testid="t-deliveryterms-input-1752672977568-22"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="col"
                                        data-testid="t-deliveryterms-div-1752672977568-81"
                                    >
                                        <ngb-timepicker
                                            formControlName="time"
                                            [readonlyInputs]="!control.get('isWeekday').value"
                                            [hourStep]="!control.get('isWeekday').value ? 0 : 1"
                                            [minuteStep]="!control.get('isWeekday').value ? 0 : 1"
                                            data-testid="t-deliveryterms-ngb-timepicker-1752672977568-2"
                                        ></ngb-timepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div
                class="form-elements--wrapper"
                data-testid="t-deliveryterms-div-1752672977568-91"
            >
                <div
                    class="add--header"
                    data-testid="t-deliveryterms-div-1752672977568-87"
                >
                    <span
                        class="h5"
                        data-testid="t-deliveryterms-span-1752672977568-19"
                    >
                        {{ 'mws.validityperiod' | i18n }}
                    </span>
                </div>
                <div
                    class="row g-3"
                    data-testid="t-deliveryterms-div-1752672977568-90"
                >
                    <div
                        class="form-group col-6"
                        data-testid="t-deliveryterms-div-1752672977568-88"
                    >
                        <app-oc-datepicker
                            [title]="'mws.datefrom' | i18n"
                            [schema]="'supplierDeliveryTermDay'"
                            [propertyName]="'validFrom'"
                            [locale]="environmentService.appSettings.locale.split('_')[0]"
                            [form]="dateFromFormDeliverydaysCustomerModalForm"
                            [disabled]="
                                systemMethod === systemMethodEnum.EDIT && !!deliverydaysCustomerModalForm.get('dateFromForm').get('date').value.singleDate
                            "
                            (dateChange)="onDateFromChanged($event, deliverydaysCustomerModalForm, deliveryFormType)"
                            data-testid="t-deliveryterms-app-oc-datepicker-1752672977568-3"
                        ></app-oc-datepicker>
                    </div>

                    <div
                        class="form-group col-6"
                        data-testid="t-deliveryterms-div-1752672977568-89"
                    >
                        <app-oc-datepicker
                            [title]="'mws.datetill' | i18n"
                            [locale]="environmentService.appSettings.locale.split('_')[0]"
                            [form]="dateTillFormDeliverydaysCustomerModalForm"
                            [disabled]="!deliverydaysCustomerModalForm.get('dateFromForm').get('date').value.singleDate"
                            [showClearDate]="deliverydaysCustomerModalForm.get('isLast').value"
                            data-testid="t-deliveryterms-app-oc-datepicker-1752672977568-4"
                        ></app-oc-datepicker>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal-footer"
            data-testid="t-deliveryterms-div-1752672977568-94"
        >
            <div
                class="button-wrapper"
                data-testid="t-deliveryterms-div-1752672977568-93"
            >
                <button
                    type="button"
                    id="deliverydays-success"
                    [attr.aria-label]="'button.check' | i18n"
                    class="btn btn-success"
                    ocPreventDoubleClick
                    (throttledClick)="checkSaveDeliveryDay(); c('Close click')"
                    [disabled]="!deliverydaysCustomerModalForm.get('changed').touched"
                    data-testid="t-deliveryterms-button-1752672977568-7"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-deliveryterms-i-1752672977568-16"
                    ></i>
                </button>
            </div>
        </div>
    </form>
</ng-template>

<ng-template
    #deliveryTermHolidaysModal
    let-c="close"
    let-d="dismiss"
>
    <!--    (ngSubmit)="submit(supplierContactForm)"-->
    <form
        [formGroup]="deliveryTermHolidaysModalForm"
        novalidate
        data-testid="t-deliveryterms-form-1752672977568-4"
    >
        <div
            class="modal-header"
            data-testid="t-deliveryterms-div-1752672977568-95"
        >
            <button
                type="button"
                id="delivery-term-holidays-cancel"
                [attr.aria-label]="'button.discard' | i18n"
                class="btn btn-close"
                ocPreventDoubleClick
                (throttledClick)="d('Close click')"
                data-testid="t-deliveryterms-button-1752672977568-8"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-deliveryterms-i-1752672977568-17"
                ></i>
            </button>
            <span
                class="h5 modal-title"
                data-testid="t-deliveryterms-span-1752672977568-20"
                >{{ 'mws.supplierholidaydeliveryadd' | i18n }}</span
            >
        </div>

        <div
            class="modal-body"
            data-testid="t-deliveryterms-div-1752672977568-99"
        >
            <div
                class="form-group"
                data-testid="t-deliveryterms-div-1752672977568-97"
            >
                <div
                    class="select-wrapper"
                    data-testid="t-deliveryterms-div-1752672977568-96"
                >
                    <select
                        formControlName="holiday"
                        class="form-select"
                        data-testid="t-deliveryterms-select-1752672977568-3"
                    >
                        @for (holiday of holidayList; track holiday) {
                            <option
                                [ngValue]="holiday.id"
                                data-testid="t-deliveryterms-option-1752672977568-4"
                            >
                                {{ holiday.descr }} ({{ holiday.holidayDate | date: 'y' }})
                            </option>
                        }
                    </select>
                </div>
            </div>
            <div
                class="form-group"
                data-testid="t-deliveryterms-div-1752672977568-98"
            >
                <ngb-timepicker
                    id="timepicker-delivery-holiday"
                    formControlName="time"
                    data-testid="t-deliveryterms-ngb-timepicker-1752672977568-3"
                ></ngb-timepicker>
            </div>

            <!--            <div class="form-group row">-->
            <!--            </div>-->
        </div>
        <div
            class="modal-footer"
            data-testid="t-deliveryterms-div-1752672977568-101"
        >
            <div
                class="button-wrapper"
                data-testid="t-deliveryterms-div-1752672977568-100"
            >
                <!--                [disabled]="!deliveryTermHolidaysModalForm.get('changed').touched"-->
                <button
                    type="button"
                    id="delivery-term-holidays-success"
                    [attr.aria-label]="'button.check' | i18n"
                    class="btn btn-success"
                    ocPreventDoubleClick
                    (throttledClick)="saveDeliveryTermHoliday(); c('Close click')"
                    data-testid="t-deliveryterms-button-1752672977568-9"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-deliveryterms-i-1752672977568-18"
                    ></i>
                </button>
            </div>
        </div>
    </form>
</ng-template>

<ng-template
    #archiveElementModal
    let-c="close"
    let-d="dismiss"
>
    <div
        class="modal-header"
        data-testid="t-deliveryterms-div-1752672977568-102"
    >
        <button
            type="button"
            id="close-archive-element-button-deliveryterms-button"
            [attr.aria-label]="'button.discard' | i18n"
            class="btn btn-close"
            ocPreventDoubleClick
            (throttledClick)="resetArchiveModal(); d('Close click')"
            data-testid="t-deliveryterms-button-1752672977568-10"
        >
            <i
                class="oc-general-cancel"
                data-testid="t-deliveryterms-i-1752672977568-19"
            ></i>
        </button>
        <span
            class="h5 modal-title"
            data-testid="t-deliveryterms-span-1752672977568-21"
            >{{ archiveElementHeader | i18n }}</span
        >
    </div>

    <div
        class="modal-body border"
        data-testid="t-deliveryterms-div-1752672977568-103"
    >
        {{ archiveElementText | i18n }}
    </div>

    <div
        class="modal-footer"
        data-testid="t-deliveryterms-div-1752672977568-105"
    >
        <div
            class="button-wrapper"
            data-testid="t-deliveryterms-div-1752672977568-104"
        >
            <button
                type="button"
                id="open-archive-element-button-deliveryterms-button"
                [attr.aria-label]="'button.check' | i18n"
                class="btn btn-success"
                ocPreventDoubleClick
                (throttledClick)="archiveElement(); c('Close click')"
                data-testid="t-deliveryterms-button-1752672977568-11"
            >
                <i
                    class="oc-general-check"
                    data-testid="t-deliveryterms-i-1752672977568-20"
                ></i>
            </button>
        </div>
    </div>
</ng-template>

<ng-template
    #selectNewFavoriteHintModal
    let-c="close"
    let-d="dismiss"
>
    <div
        class="modal-header"
        data-testid="t-deliveryterms-div-1752672977568-106"
    >
        <button
            type="button"
            [attr.aria-label]="'button.discard' | i18n"
            class="btn btn-close"
            ocPreventDoubleClick
            (throttledClick)="d('Close click')"
            data-testid="t-deliveryterms-button-1752672977568-12"
        >
            <i
                class="oc-general-cancel"
                data-testid="t-deliveryterms-i-1752672977568-21"
            ></i>
        </button>
        <span
            class="h5 modal-title"
            data-testid="t-deliveryterms-span-1752672977568-22"
            >{{ 'prompt.info' | i18n }}</span
        >
    </div>

    <div
        class="modal-body"
        data-testid="t-deliveryterms-div-1752672977568-107"
    >
        {{ 'mws.select.favorite.customer.hint' | i18n }}
    </div>

    <div
        class="modal-footer"
        data-testid="t-deliveryterms-div-1752672977568-109"
    >
        <div
            class="button-wrapper"
            data-testid="t-deliveryterms-div-1752672977568-108"
        >
            <button
                type="button"
                [attr.aria-label]="'button.check' | i18n"
                class="btn btn-success"
                ocPreventDoubleClick
                (throttledClick)="c('Close click')"
                data-testid="t-deliveryterms-button-1752672977568-13"
            >
                <i
                    class="oc-general-check"
                    data-testid="t-deliveryterms-i-1752672977568-22"
                ></i>
            </button>
        </div>
    </div>
</ng-template>

<ng-template
    #selectNewFavoriteAddressHintModal
    let-c="close"
    let-d="dismiss"
>
    <div
        class="modal-header"
        ngbAutofocus
        data-testid="t-deliveryterms-div-1752672977568-110"
    >
        <button
            type="button"
            [attr.aria-label]="'button.discard' | i18n"
            class="btn btn-close"
            ocPreventDoubleClick
            (throttledClick)="closeModal()"
            data-testid="t-deliveryterms-button-1752672977568-14"
        >
            <i
                class="oc-general-cancel"
                data-testid="t-deliveryterms-i-1752672977568-23"
            ></i>
        </button>
        <span
            class="h5 modal-title"
            data-testid="t-deliveryterms-span-1752672977568-23"
            >{{ 'prompt.info' | i18n }}</span
        >
    </div>

    <div
        class="modal-body border"
        data-testid="t-deliveryterms-div-1752672977568-111"
    >
        {{ 'mws.select.favorite.address.hint' | i18n }}
    </div>

    <div
        class="modal-footer"
        data-testid="t-deliveryterms-div-1752672977568-113"
    >
        <div
            class="button-wrapper"
            data-testid="t-deliveryterms-div-1752672977568-112"
        >
            <button
                type="button"
                [attr.aria-label]="'button.check' | i18n"
                class="btn btn-success"
                ocPreventDoubleClick
                (throttledClick)="closeModal()"
                data-testid="t-deliveryterms-button-1752672977568-15"
            >
                <i
                    class="oc-general-check"
                    data-testid="t-deliveryterms-i-1752672977568-24"
                ></i>
            </button>
        </div>
    </div>
</ng-template>
<ng-template
    #setValidTillHintModal
    let-c="close"
    let-d="dismiss"
>
    <div
        class="modal-header"
        ngbAutofocus
        data-testid="t-deliveryterms-div-1752672977568-114"
    >
        <button
            type="button"
            [attr.aria-label]="'button.discard' | i18n"
            class="btn btn-close"
            (click)="d('Close click')"
            data-testid="t-deliveryterms-button-1752672977568-16"
        >
            <i
                class="oc-general-cancel"
                data-testid="t-deliveryterms-i-1752672977568-25"
            ></i>
        </button>
        <span
            class="h5 modal-title"
            data-testid="t-deliveryterms-span-1752672977568-24"
            >{{ 'prompt.info' | i18n }}</span
        >
    </div>

    <!--    <div class="modal-body border">{{ 'mws.select.favorite.customer.hint' | i18n }}</div>-->
    @if (setValidTillHintModalVersion === orderFormType) {
        <div
            class="modal-body border"
            data-testid="t-deliveryterms-div-1752672977568-115"
        >
            Durch diese Aktion wird automatisch "gültig bis" für die Bestelltage gesetzt, die keine "Gültigkeit bis" gesetzt haben. Nur der letzte Eintrag darf
            keine "Gültigkeit bis" haben. Möchten Sie fortfahren?
        </div>
    }
    @if (setValidTillHintModalVersion === deliveryFormType) {
        <div
            class="modal-body border"
            data-testid="t-deliveryterms-div-1752672977568-116"
        >
            Durch diese Aktion wird automatisch "gültig bis" für die Liefertage gesetzt, die keine "Gültigkeit bis" gesetzt haben. Nur der letzte Eintrag darf
            keine "Gültigkeit bis" haben. Möchten Sie fortfahren?
        </div>
    }

    <div
        class="modal-footer"
        data-testid="t-deliveryterms-div-1752672977568-118"
    >
        <div
            class="button-wrapper"
            data-testid="t-deliveryterms-div-1752672977568-117"
        >
            <button
                type="button"
                [attr.aria-label]="'button.discard' | i18n"
                class="btn btn-danger me-2"
                (click)="c('Close click')"
                data-testid="t-deliveryterms-button-1752672977568-17"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-deliveryterms-i-1752672977568-26"
                ></i>
            </button>
            @if (setValidTillHintModalVersion === orderFormType) {
                <button
                    [attr.aria-label]="'button.check' | i18n"
                    class="btn btn-success"
                    ocPreventDoubleClick
                    (throttledClick)="saveOrderday(); c('Close click')"
                    data-testid="t-deliveryterms-button-1752672977568-18"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-deliveryterms-i-1752672977568-27"
                    ></i>
                </button>
            }
            @if (setValidTillHintModalVersion === deliveryFormType) {
                <button
                    [attr.aria-label]="'button.check' | i18n"
                    class="btn btn-success"
                    ocPreventDoubleClick
                    (throttledClick)="saveDeliverydays(); c('Close click')"
                    data-testid="t-deliveryterms-button-1752672977568-19"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-deliveryterms-i-1752672977568-28"
                    ></i>
                </button>
            }
        </div>
    </div>
</ng-template>
